import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME } from './constants';

export const PRReturnNAME = <const>'PRReturn';


class NdPrijemkaPolozkyProvider extends BaseApi {
	updateLeftToDeliverCount(MioId: number, lefttodelivercount:number) {
		return this.fetch(`/${MODULE_API}/${PRReturnNAME}/UpdateleftToDeliverCount`, { MioId, lefttodelivercount });
	}
	checkAvailableQuantity(recieptItemId: number, partNo:string) {
		return this.fetch(`/${MODULE_API}/${PRReturnNAME}/checkAvailableQuantity`, { recieptItemId, partNo });
	}
}

export const apiProvider = new NdPrijemkaPolozkyProvider(MODULE_API, NAME);
